/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');
var linkifyHtml = require('linkifyjs/html');

module.exports = function (helpers, utils) {
    return {
        linkify: function (options, str, formatUrl) {
            var linkifyOptions = {
                linkClass: ' ',
                formatHref: function (value, type) {
                    if (type === 'url') {
                        if (_.isFunction(formatUrl)) {
                            value = formatUrl(value, options);
                        }
                    }
                    return value;
                },
                format: function (value, type) {
                    if (type === 'url') {
                        /* remove leading http:// or https:// */
                        value = value.replace(/^((http:\/\/)|(https:\/\/))/i, '');

                        if (value.length > 40) {
                            value = value.slice(0, 40) + '\u2026';
                        }
                    }
                    return value;
                }
            };
            return utils.safeString(linkifyHtml(str, linkifyOptions));
        }
    };
};

